<template>
  <value-container v-if="view_only" :value="view_only_value" :label="label" :md="md"/>
  <v-flex :md3="md==3" :md4="md==4" v-else>
    <b><fs1-span>{{label}}</fs1-span></b>
    <v-select
      :placeholder="value ? undefined : ' seleccionar'"
      v-model="model"
      :items="items"
      :item-text="item_text||'name'"
      :item-value="item_value||'id'"
      :disabled="disabled"
      :multiple="multiple"
      :class="multiple ? (value === null && 'textEmpty'): ((value === undefined || value === null || value.length === 0) && 'textEmpty')"/>
  </v-flex>
</template>
<script>
export default {
  props: ['label','value','md','disabled','items','item_value','item_text','multiple','view_only'],
  data() {
    return { model:null }
  },
  computed:{
    view_only_value(){ return (this.items.find(f=>f.id===this.value)||{}).name }
  },
  watch: {
    'value'(v){ this.model=v },
    'model'(v){ this.$emit('update:value', v) }
  },
  created(){ this.model=[undefined].includes(this.value)?null:this.value },
};
</script>
